import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import { Features } from '@drl/core/auth/models/features.model';

@Injectable()
export class FeatureConfigAdapter implements IAdapter<Features> {
  adaptToModel(resp: any): Features {
    return new Features(resp);
  }
  adaptFromModel(data: Features): any {
    return data;
  }
}
